import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from "react-router-dom";
import './headerTitliStyle.scss'
import { AuthState } from '../../../context/AuthProvider'
import { useDispatch, useSelector } from 'react-redux';
import { PrintDataTitli } from '../../../comonComponent/print-titli/PrintTitli';
import moment from "moment";
import { SocketState } from '../../../context/SocketProvider';
import { SHOW_MAIN_ERROR_MODAL } from '../../../redux/errorMessageSlice';
import TimerControl from './TimerControl';
import { SET_TITLI_ADVANCE_DRAW_SELECT_TIME, SelectTitliCurrentGameTime, SET_TITLI_CLAIM_TICKET_ID, SelectTitliClaimTicket, SET_TITLI_CLAIM_TICKET_RECORD, SelectTitliLastWinCard, SelectTitliAdvanceDrawSelectTime, SelectTitliUserWallet, SET_TITLI_LAST_SALE_AMOUNT, SET_TITLI_LAST_TICKET_ID, SET_TITLI_PRINT_DATA } from '../../../redux/titli-slice/gameInfoTitliSlice';
import { SET_MAIN_LOADER } from '../../../redux/loaderSlice';
import { useNavigate } from 'react-router-dom';
import { RESET_TITLI_SLICE_STATE } from '../../../redux/titli-slice/seriesSliceTitli';
import { setAdvanceTimeSlotCount } from '../../../redux/seriesSlice';
import ResultHistory from './ResultHistory';

const Titli = () => {
  const location = useLocation();

  let { userDetail } = AuthState()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  let { socket } = SocketState()
  // State declarations
  let userWallet = useSelector(SelectTitliUserWallet);
  const lastWinCards = useSelector(SelectTitliLastWinCard);
  let currentDrawTime = useSelector(SelectTitliCurrentGameTime);
  let AdvanceDrawSelectTime = useSelector(SelectTitliAdvanceDrawSelectTime);
  const [currentTime, setCurrentTime] = useState(moment().format('D/M/yyyy, h:mm:ss A'));
  // console.log(lastWinCards)

  const [imagesRefresh, setImagesRefresh] = useState(0);

  const ticketID = useSelector(SelectTitliClaimTicket)
  useEffect(() => {
    if (ticketID.length >= 10) {
      claimTicket()
    }
  }, [ticketID])

  useEffect(() => {
    return () => {
      dispatch(SET_TITLI_CLAIM_TICKET_RECORD({}))
      dispatch(SET_TITLI_CLAIM_TICKET_ID(''))
    }
  }, [])

  let claimTicket = () => {
    dispatch(SET_MAIN_LOADER(true))
    var data = {
      "en": "LUCKY_SORAT_CLAIM_TICKET",
      "data": {
        "ticket_id": ticketID,
      }
    }
    socket.emit("req", data);
    dispatch(SET_TITLI_CLAIM_TICKET_ID(''))
    // setTicketId('')
  }

  // useEffect(() => {
  // // 🔁 Reinitialize all your states here
  //   // console.log("Last Win Cards updated:", lastWinCards);
  //   // console.log("🎯 Titli reinitialized!");

  // }, [location.key]); 

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(moment().format('D/M/yyyy, h:mm:ss A')); // 12-hour format with AM/PM
    }, 1000);

    return () => clearInterval(timer); // Clean up on unmount
  }, []);

  const [ticketPrice, setTicketPrice] = useState(10);
  const [showWhatsappPopup, setShowWhatsappPopup] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");

  // Ticket quantities for each number (1-12)
  const [ticketQuantities, setTicketQuantities] = useState(Array(12).fill(0));
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);

  // Advance draw states
  const [totalAdvanceGames, setTotalAdvanceGames] = useState(0);

  // Result states

  // Refs for input focus
  const ticketInputRefs = useRef([]);

  const parseCard = (card) => {
    const [name, num, time] = card.split("|");
    return { name, num, time };
  };

  // Initialize input refs
  useEffect(() => {
    ticketInputRefs.current = ticketInputRefs.current.slice(0, 12);
  }, []);

  // Calculate totals when quantities change
  useEffect(() => {
    const totalQty = ticketQuantities.reduce((sum, qty) => sum + qty, 0);
    const totalAmt = totalQty * ticketPrice * (AdvanceDrawSelectTime.length > 0 ? AdvanceDrawSelectTime.length : 1);
    setTotalQuantity(totalQty);
    setTotalAmount(totalAmt);
  }, [ticketQuantities, ticketPrice, AdvanceDrawSelectTime]);

  // Animal images mapping
  const animalImages = {
    "Ball": 'images/football111.gif',
    "Kite": 'images/kitework123.gif',
    "Cow": 'images/cat1212.gif',
    "Gariyo": 'images/horse1.gif',
    "Amrela": 'images/umbrela11.gif',
    "WatterDoll": 'images/bullet121.gif',
    "Butterfly": 'images/butterfly2121.gif',
    "Rose": 'images/rose132.gif',
    "Sun": 'images/tiger11.gif',
    "Lamp": 'images/dipak1231.gif',
    "Egle": 'images/kabutar123.gif',
    "Rebit": 'images/rabit132.gif'
  };

  const animalList = Object.keys(animalImages);

  // Handle ticket quantity change
  const handleTicketQuantityChange = (index, value, event) => {
    const newQuantities = [...ticketQuantities];
    newQuantities[index] = parseInt(value) || 0;
    setTicketQuantities(newQuantities);

    // Handle arrow key navigation
    if (event) {
      handleArrowKeyNavigation(index, event.keyCode);
    }
  };

  // Handle arrow key navigation between ticket inputs
  const handleArrowKeyNavigation = (currentIndex, keyCode) => {
    let newIndex;

    switch (keyCode) {
      case 37: // Left arrow
        newIndex = currentIndex === 0 ? 11 : currentIndex - 1;
        break;
      case 39: // Right arrow
        newIndex = currentIndex === 11 ? 0 : currentIndex + 1;
        break;
      case 38: // Up arrow
        newIndex = currentIndex <= 5 ? currentIndex + 6 : currentIndex - 6;
        if (newIndex > 11) newIndex -= 12;
        break;
      case 40: // Down arrow
        newIndex = currentIndex >= 6 ? currentIndex - 6 : currentIndex + 6;
        if (newIndex < 0) newIndex += 12;
        break;
      default:
        return;
    }
    if (ticketInputRefs.current[newIndex]) {
      ticketInputRefs.current[newIndex].focus();
    }
  };


  // Handle buy tickets
  const handleBuyTickets = () => {
    dispatch(SET_MAIN_LOADER(true));

    // ✅ Always use current state snapshot
    const currentQuantities = [...ticketQuantities];
    // console.log(currentQuantities) 
    const card_details = {};

    animalList.forEach((animal, index) => {
      const i = index + 1;
      if (currentQuantities[i] > 0) {
        card_details[animal] = currentQuantities[i] * 10;
      }
    });

    const mobile_number = localStorage.getItem("mobile_number") ?? null;

    // console.log("Buying tickets:", {
    //   advance_bet: AdvanceDrawSelectTime.length > 0,
    //   advance_bet_times: AdvanceDrawSelectTime,
    //   card_details,
    //   mobile_number,
    // });

    socket.emit("req", {
      en: "LUCKY_SORAT_PLACE_BET",
      data: {
        advance_bet: AdvanceDrawSelectTime.length > 0,
        advance_bet_times: AdvanceDrawSelectTime,
        card_details,
        mobile_number,
      },
    });

    localStorage.removeItem("mobile_number");
    // Reset after socket emit (not before)
    setTicketQuantities(Array(animalList.length).fill(0));
  };

  useEffect(() => {
    if (!socket) return;

    const listener = (socketData) => {
      if (socketData.en === "LUCKY_SORAT_PLACE_BET") {
        if (socketData.err) {
          dispatch(SHOW_MAIN_ERROR_MODAL(socketData.msg));
          return;
        }

        dispatch(SET_TITLI_LAST_SALE_AMOUNT(socketData.data.total_bet_amount));
        dispatch(SET_TITLI_LAST_TICKET_ID(socketData.data.ticket_id));

        if (!userDetail?.user_bet) {
          PrintDataTitli(socketData.data, dispatch);
        }
        dispatch(SET_MAIN_LOADER(false));
        dispatch(RESET_TITLI_SLICE_STATE());
        dispatch(SET_TITLI_ADVANCE_DRAW_SELECT_TIME([]));
        dispatch(setAdvanceTimeSlotCount(0));
      }
    };

    socket.on("res", listener);

    return () => {
      socket.off("res", listener);
    };
  }, [socket]); // <-- userDetail hata diya

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "F6") {
        event.preventDefault();
        handleBuyTickets();
      }
    };

    // Listen for custom event from WhatsApp popup
    const handleWhatsappPlaceBetTitli = () => {
      handleBuyTickets();
    };

    window.addEventListener("keydown", handleKeyDown);
    window.addEventListener("whatsappPlaceBetTitli", handleWhatsappPlaceBetTitli);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
      window.removeEventListener("whatsappPlaceBetTitli", handleWhatsappPlaceBetTitli);
    };
  }, [handleBuyTickets]);


  return (<>
    <table className="silver-coin-12d" style={{ width: '100%', backgroundSize: 'cover', margin: '0px !important' }}>
      <tbody>

        <tr>
          <td width="100%;">
            <table width="100%;">
              <tbody>
                <tr>
                  <td width="20%;">
                    <div
                      style={{
                        border: '#5f5f5f solid 2px',
                        height: '80px',
                        background: 'red',
                      }}
                    >
                      <div className="content">
                        <h2 className="text-shadows"> TITLI</h2>
                      </div>
                    </div>
                    <table width="100%;">
                      <tbody>
                        <tr>
                          <td width="100%;">
                            <div
                              style={{
                                height: '50px',
                                padding: '10px',
                                background: 'linear-gradient(to top,#000000,#5f5f5f)',
                              }}
                            >
                              <center>
                                <h4 style={{ color: '#fff' }}>
                                  <b> {userDetail?.user_name || ''}</b>
                                </h4>
                              </center>
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td width="100%;">
                            <div
                              style={{
                                height: '50px',
                                padding: '13px',
                                borderRadius: '0'
                              }}
                              className="btn-grad5"
                            >
                              <center>
                                <h4 style={{ color: '#fff', marginBottom: '0px' }}>
                                  <b
                                  >Points:
                                    <span
                                      style={{
                                        fontSize: '24px',
                                        fontWeight: 'bold',
                                        color: 'white'
                                      }}
                                      id="BalPt"
                                    >{userWallet || 0}</span></b>
                                </h4>
                              </center>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                  <td width="80%;">
                    <ResultHistory />
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>

        <tr>
          <td width="100%">
            <table width="100%">
              <tbody>
                <tr>
                  <td width="20%">
                    <div
                      style={{ padding: '5px', borderRadius: '0' }}
                      className="btn-grad9"
                    >
                      <center>
                        <h5 style={{ color: ' #fff' }}>
                          <b>
                            <span
                              id="transaction_time"
                              style={{ fontSize: '1.25rem', fontWeight: 'bold' }}
                            >{currentTime}</span></b>
                        </h5>
                      </center>
                    </div>
                  </td>
                  <td width="20%">
                    <div
                      style={{ padding: '5px', borderRadius: '0' }}
                      className="btn-grad7"
                    >
                      <center>
                        <h5 style={{ color: ' #fff' }}>
                          <b>Last Draw - {currentDrawTime ? moment(currentDrawTime, 'D/M/yyyy, h:mm:ss A').subtract(5, 'minutes').format('hh:mm A') : ''} </b>
                        </h5>
                      </center>
                    </div>
                  </td>
                  <td width="20%">
                    <div
                      style={{ padding: '5px', borderRadius: '0' }}
                      className="btn-grad6"
                    >
                      <center>
                        <h5 style={{ color: ' #fff' }}>
                          <b>Current Draw - {currentDrawTime ? moment(currentDrawTime, 'D/M/yyyy, h:mm:ss A').format('hh:mm A') : ''} </b>
                        </h5>
                      </center>
                    </div>
                  </td>
                  <td width="20%">
                    <div
                      style={{
                        border: '#5f5f5f solid 2px',
                        height: '37.5px',
                        padding: '0.5px',
                        color: 'red',
                        background: '#fff'
                      }}
                    >
                      <center>
                        <h5>
                          <b
                          >Remain Time -
                            <span
                              id="remaintime"
                              style={{
                                fontSize: '24px',
                                fontWeight: '800',
                                color: 'red',
                              }}
                            ><TimerControl /></span></b>
                        </h5>
                      </center>
                    </div>
                  </td>
                  <td width="20%">
                    <center>
                      <a
                        onClick={() => {
                          localStorage.clear()
                          socket.disconnect()
                        }}
                        className="tag1">
                        <h5
                          style={{
                            marginBottom: '0px',
                            color: '#fff',
                            fontSize: '20px',
                            padding: '6px',
                            borderRadius: '0',
                          }}
                          className="btn-grad8"
                        >
                          Exit
                        </h5>
                      </a>
                    </center>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>

        <tr>
          <td width="100%">
            <table width="100%">
              <tbody>
                <tr>
                  <td width="12%">
                    <center>
                      <a
                        onClick={() => {
                          dispatch(SET_TITLI_ADVANCE_DRAW_SELECT_TIME([]))
                          dispatch(setAdvanceTimeSlotCount(0))
                          setTicketQuantities(Array(animalList.length).fill(0));
                        }}
                        className="tag1">
                        <h5
                          style={{
                            marginBottom: '0px',
                            color: '#fff',
                            fontSize: '20px',
                            padding: '6px',
                            borderRadius: '0',
                          }}
                          className="btn-grad2"
                        >
                          REFRESH
                        </h5>
                      </a>
                    </center>
                  </td>
                  <td width="12%">
                    <center>
                      <a
                        onClick={() => navigate('account')}
                        className="tag1">
                        <h5
                          style={{
                            marginBottom: '0px',
                            color: '#fff',
                            fontSize: '20px',
                            padding: '6px',
                            borderRadius: '0',
                          }}
                          className="btn-grad7"
                        >
                          Account
                        </h5>
                      </a>
                    </center>
                  </td>
                  <td width="12%">
                    <center>
                      <a onClick={() => navigate('result')}
                        target="_blank" className="tag1">
                        <h5
                          style={{
                            marginBottom: '0px',
                            color: '#fff',
                            fontSize: '20px',
                            padding: '6px',
                            borderRadius: '0',
                          }}
                          className="btn-grad6"
                        >
                          RESULT
                        </h5>
                      </a>
                    </center>
                  </td>
                  <td width="12%">
                    <center>
                      <a onClick={() => navigate('reprint')} className="tag1">
                        <h5
                          style={{
                            marginBottom: '0px',
                            color: '#fff',
                            fontSize: '20px',
                            padding: '6px',
                            borderRadius: '0',
                          }}
                          className="btn-grad3"
                        >
                          Reprint
                        </h5>
                      </a>
                    </center>
                  </td>
                  <td width="12%">
                    <center>
                      <a
                        onClick={() => navigate('cancelCoupon')}
                        // href="cancel_tick1.aspx"
                        target="_blank"
                        className="tag1"
                      >
                        <h5
                          style={{
                            marginBottom: '0px',
                            color: '#fff',
                            fontSize: '20px',
                            padding: '6px',
                            borderRadius: '0',
                          }}
                          className="btn-grad8"
                        >
                          CANCEL
                        </h5>
                      </a>
                    </center>
                  </td>
                  <td width="14%">
                    <center>
                      <a
                        type="button"
                        className={`btn-hover color-17 ${totalAdvanceGames > 0 ? 'answerBtnsOnss' : ''}`}
                        href="javascript:void(0)"
                        onClick={() => navigate('advance')}
                        id="myBtn"
                      ><h5 style={{
                        marginBottom: '0px',
                        color: '#fff',
                        fontSize: '20px',
                        padding: '6px 12px',
                        borderRadius: '0',
                        border: 'none',
                      }}
                        className="btn-grad7"
                      >
                          {totalAdvanceGames > 0 ? `Advance Draw-${totalAdvanceGames}` : 'Advance Draw'}
                        </h5>
                      </a>
                    </center>
                  </td>
                  <td width="6%">
                    <center>
                      <a
                        onClick={() => {
                          socket.emit('req', {
                            en: "LOTTARY_CLOSE_GAME",
                            data: {}
                          });
                          navigate("/1d");
                          localStorage.setItem("gameRoute", "1d")
                        }}
                        className="tag1">
                        <h5

                          style={{
                            marginBottom: '0px',
                            color: '#fff',
                            background: 'linear-gradient(171.8deg, rgb(18, 113, 235) 13.5%, rgb(13, 57, 112) 78.6%)',
                            fontSize: '20px',
                            padding: '6px',
                          }}
                        >
                          2D
                        </h5>
                      </a>
                    </center>
                  </td>
                  <td width="6%">
                    <center>
                      <a
                        onClick={() => {
                          socket.emit('req', {
                            en: "LOTTARY_CLOSE_GAME",
                            data: {}
                          });
                          navigate("/2d");
                          localStorage.setItem("gameRoute", "2d")
                        }}
                        className="tag1">
                        <h5

                          style={{
                            marginBottom: '0px',
                            color: '#fff',
                            background: 'linear-gradient(171.8deg, rgb(18, 113, 235) 13.5%, rgb(13, 57, 112) 78.6%)',
                            fontSize: '20px',   
                            padding: '6px',
                          }}
                        >
                          4D
                        </h5>
                      </a>
                    </center>
                  </td>
                  
                  <td width="6%">
                    <center>
                      <a
                        onClick={() => {
                          socket.emit('req', {
                            en: "LOTTARY_CLOSE_GAME",
                            data: {}
                          });
                          navigate("/3d");
                          localStorage.setItem("gameRoute", "3d")
                        }}
                        className="tag1">
                        <h5
                          style={{
                            marginBottom: '0px',
                            color: '#fff',
                            background: 'linear-gradient(171.8deg, rgb(18, 113, 235) 13.5%, rgb(13, 57, 112) 78.6%)',
                            fontSize: '20px',
                            padding: '6px',
                          }}
                        >
                          3D
                        </h5>
                      </a>
                    </center>
                  </td>
                  <td width="6%">
                    <center>
                      <a
                        onClick={() => {
                          localStorage.setItem("gameRoute", "pana")
                          navigate("/pana-game")
                        }}
                        className="tag1">
                        <h5
                          style={{
                            marginBottom: '0px',
                            color: '#fff',
                            background: 'linear-gradient(171.8deg, rgb(18, 113, 235) 13.5%, rgb(13, 57, 112) 78.6%)',
                            fontSize: '20px',
                            padding: '6px',
                          }}
                        >
                          Pana
                        </h5>
                      </a>
                    </center>
                  </td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>

        <tr>
          <td width="100%">
            <input type="hidden" value="10" id="tickpriceid" />
            <input type="hidden" value="38448" id="useriddd" />
            <table width="100%">
              <tbody>
                <tr>
                  <td width="100%">
                    <table width="100%;">
                      <tbody>
                        {[0, 1].map((row) => (
                          <tr key={row}>
                            {animalList.slice(row * 6, row * 6 + 6).map((animal, index) => {
                              const number = row * 6 + index + 1;
                              return (
                                <td key={animal} width="16.67%">
                                  <center>
                                    <div
                                      className="block"
                                      style={{
                                        border: 'red solid 6px',
                                        borderRadius: '25px',
                                        width: '95% !important',
                                        height: '185px',
                                        backgroundSize: 'cover',
                                        textAlign: 'center',
                                        boxShadow: '0 0 15px #a0522d',
                                        marginBottom: '10px',
                                      }}
                                    >
                                      <center>
                                        <img
                                          src={animalImages[animal]}
                                          alt={animal}
                                          style={{ width: number === 2 ? '130px' : number === 3 ? '140px' : number === 4 ? '140px' : number === 5 ? '120px' : number === 6 ? '150px' : number === 7 ? '140px' : number === 8 ? '150px' : number === 9 ? '145px' : number === 10 ? '100px' : number === 11 ? '100px' : number === 12 ? '110px' : '100px', height: '100px', marginTop: '10px', marginRight: number === 2 ? '-25px' : '0' }}
                                        />
                                      </center>
                                      <center>
                                        <input
                                          id={`ticknum${number}0`}
                                          autocomplete="off"
                                          pattern="/^-?\d+\.?\d*$/"
                                          onKeyPress={(e) => {
                                            if (e.target.value.length === 3) e.preventDefault();
                                            if (!/[0-9]/i.test(e.key)) e.preventDefault();
                                          }}
                                          onChange={(e) => {
                                            let value = parseInt(e.target.value) || 0;
                                            if (value < 0) value = 0;
                                            if (value > 999) value = 999;
                                            handleTicketQuantityChange(number, value, null);
                                          }}
                                          onKeyUp={(e) => {
                                            let value = parseInt(e.target.value) || 0;
                                            if (value < 0) value = 0;
                                            if ([37, 38, 39, 40].includes(e.keyCode)) {
                                              handleTicketQuantityChange(number, value, e);
                                            }
                                          }}
                                          type="number"
                                          onFocus={(e) => e.target.select()}
                                          name=""
                                          className="third"
                                          min="0"
                                          max="999"
                                          placeholder={number}
                                          value={ticketQuantities[number] || ''}
                                          style={{
                                            width: '70%',
                                            marginTop: '10px',
                                            height: '45px',
                                            borderRadius: '30px',
                                            border: '#000 solid 3px',
                                          }}
                                        />
                                      </center>
                                    </div>
                                  </center>
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </td>
                </tr>
              </tbody>
            </table>
            <table width="100%">
              <tbody>
                <tr>
                  <td width="25%">
                    <div style={{ border: '#5f5f5f solid 2px' }}>
                      <center>
                        <h5
                          style={{ marginBottom: '0px', padding: '8px', color: '#000' }}
                        >
                          Last Trsn. #,&nbsp;Pt(2)
                        </h5>
                      </center>
                    </div>
                  </td>

                  {userDetail?.auto_claim == false && (
                    <td width="15%">
                      <input
                        type="text"
                        placeholder="Enter Ticket ID Claim"
                        value={ticketID}
                        onChange={(e) => dispatch(SET_TITLI_CLAIM_TICKET_ID(e.target.value))}

                        onKeyDown={(e) => {
                          if (e.code === "Space") {
                            e.preventDefault();   // space input me na aaye
                            e.target.select();    // pura text select ho jaye
                          }
                        }}

                        style={{
                          width: "100%",
                          padding: "6px",
                          border: "2px solid #000",
                          borderRadius: "5px"
                        }}
                      />
                    </td>)}
                  <td width="15%">
                    <div>
                      <center>
                        <input
                          type="number"
                          className="third"
                          readOnly
                          id="totqnt"
                          value={totalQuantity}
                          style={{
                            border: '#000 solid 2px',
                            fontSize: '24px !important',
                            fontWeight: '600 !important',
                            width: '100%',
                            fontSize: '20px',
                            fontWeight: 'bold',
                            background: '#dfdfdf',
                          }}
                        />
                      </center>
                    </div>
                  </td>
                  <td width="15%">
                    <div>
                      <div>
                        <center>
                          <input
                            type="number"
                            className="third"
                            readOnly
                            id="totamt"
                            value={totalAmount}
                            style={{
                              border: '#000 solid 2px',
                              fontSize: '24px !important',
                              fontWeight: '600 !important',
                              width: '100%',
                              fontSize: '20px',
                              fontWeight: 'bold',
                              background: '#dfdfdf',
                            }}
                          />
                        </center>
                      </div>
                    </div>
                  </td>
                  {userDetail?.whatsapp && (
                    <td width="15%">
                      <div>
                        <center>
                          <div
                            style={{
                              width: '100%',
                              background: 'linear-gradient(171.8deg, rgb(35, 148, 12) 13.5%, rgb(10, 106, 34) 78.6%)',
                              color: '#fff',
                              width: '100%',
                              padding: '5px',
                              cursor: 'pointer'
                            }}
                            onClick={() => setShowWhatsappPopup(true)}
                            id="buybutton"
                          >
                            WhatsApp
                          </div>
                        </center>
                      </div>
                    </td>)}

                  {userDetail?.print && (
                    <td width="15%">
                      <div>
                        <center>
                          <div
                            style={{
                              width: '100%',
                              background: 'linear-gradient(171.8deg, rgba(12, 32, 148, 1) 13.5%, rgba(12, 10, 106, 1) 78.6%)',
                              color: '#fff',
                              width: '100%',
                              padding: '5px',
                              cursor: 'pointer'
                            }}
                            onClick={handleBuyTickets}
                            id="buybutton"
                          >
                            Print
                          </div>
                        </center>
                      </div>
                    </td>)}

                  {userDetail?.user_bet && (
                    <td width="15%">
                      <div>
                        <center>
                          <div
                            style={{
                              width: '100%',
                              background: 'linear-gradient(171.8deg, rgba(12, 32, 148, 1) 13.5%, rgba(12, 10, 106, 1) 78.6%)',
                              color: '#fff',
                              width: '100%',
                              padding: '5px',
                              cursor: 'pointer'
                            }}
                            onClick={() => { handleBuyTickets() }}
                            id="buybutton"
                          >
                            Bet
                          </div>
                        </center>
                      </div>
                    </td>)}
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
      </tbody>
      {/* Main Layout Table converted to div structure */}



      {/* Add other modals (result, etc.) as needed */}
    </table>

    {showWhatsappPopup && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0,0,0,0.6)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999,
        }}
      >
        <div
          style={{
            background: "#fff",
            padding: "20px 30px",
            borderRadius: "10px",
            boxShadow: "0 0 15px rgba(0,0,0,0.3)",
            width: "300px",
            textAlign: "center",
          }}
        >
          <h3 style={{ marginBottom: "15px" }}>Enter Mobile Number</h3>
          <input
            type="tel"
            placeholder="Enter mobile number"
            value={mobileNumber}
            onChange={(e) => {
              const value = e.target.value
              if (value.length > 10) {
                alert("Mobile number must be 10 digits only")
                return
              }
              if (/^\d*$/.test(value)) {
                setMobileNumber(value)
              }
            }}
            style={{
              width: "100%",
              padding: "8px",
              borderRadius: "5px",
              border: "1px solid #ccc",
              marginBottom: "15px",
            }}
          />
          <div style={{ display: "flex", justifyContent: "space-around" }}>
            <button
              style={{
                backgroundColor: "#28a745",
                color: "#fff",
                border: "none",
                padding: "8px 12px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
              onClick={() => {
                if (mobileNumber.trim().length < 10) {
                  alert("Please enter a valid mobile number");
                  return;
                }
                localStorage.setItem("mobile_number", mobileNumber);

                // Call PlaceBat2d directly
                const placeBetEvent = new Event("whatsappPlaceBetTitli");
                window.dispatchEvent(placeBetEvent);

                setShowWhatsappPopup(false);
                setMobileNumber("");
              }}
            >
              Submit
            </button>
            <button
              style={{
                backgroundColor: "#dc3545",
                color: "#fff",
                border: "none",
                padding: "8px 12px",
                borderRadius: "5px",
                cursor: "pointer",
              }}
              onClick={() => {
                setShowWhatsappPopup(false);
                setMobileNumber("");
              }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    )}
  </>
  );
};

export default Titli;